var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1584_1026)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.0001,
    cy: 28,
    r: 20.5333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0001,
    cy: 28,
    r: 20.5333,
    fill: "#2E7D32",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 53.4179C42.0379 53.4179 53.4179 42.0379 53.4179 28C53.4179 13.9621 42.0379 2.58212 28 2.58212C13.9621 2.58212 2.58212 13.9621 2.58212 28C2.58212 42.0379 13.9621 53.4179 28 53.4179ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#2E7D32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 53.4179C42.0379 53.4179 53.4179 42.0379 53.4179 28C53.4179 13.9621 42.0379 2.58212 28 2.58212C13.9621 2.58212 2.58212 13.9621 2.58212 28C2.58212 42.0379 13.9621 53.4179 28 53.4179ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9202 29.0216L35.1067 18.6667L38.9122 22.5352L24.9202 36.7586L16.7998 28.5039L20.6054 24.6354L24.9202 29.0216Z",
    fill: "#2E7D32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9202 29.0216L35.1067 18.6667L38.9122 22.5352L24.9202 36.7586L16.7998 28.5039L20.6054 24.6354L24.9202 29.0216Z",
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1584_1026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success.1d02887d7041da7015e6a632c0e124f8.svg";